import moment from 'moment/moment';

export const getDateValue = (value) => {
  const momentDate = moment(value, 'DD.MM.YYYY');
  return value.length === 10 && momentDate.isValid()
    ? new Date(momentDate.format('YYYY-MM-DD'))
    : null;
};
